import { handleVersionMismatch } from 'actions/versionSync';
import { FETCH_FEED_MESSAGES_SUCCESS, } from 'actiontypes/messages';
import { VersionMismatch } from 'services/BaseService';
import MessagesService from 'services/MessagesService';
import { IMessagesService } from 'types/messages';

import { FEED_MESSAGES, fetchRequested, } from './fetch';

export default fetchFeedMessages(new MessagesService());

export function fetchFeedMessages(service: IMessagesService) {
  return () => async (dispatch: Function) => {
    try {
      dispatch(fetchRequested(FEED_MESSAGES));
      return await service.fetch('feed');
    } catch (e) {
      if (e instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(e));
        return;
      }
      throw e;
    }
  };
}

export const fetchFeedMessagesSuccess = (data: any) => ({
  type: FETCH_FEED_MESSAGES_SUCCESS,
  payload: data,
});